import script from "./SettingsPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./SettingsPanel.vue?vue&type=script&lang=ts&setup=true"

import "./SettingsPanel.vue?vue&type=style&index=0&id=11404b8e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11404b8e"]])

export default __exports__